<template>

<div style="background: white" class="model-table-editor">

        <v-sheet class="header-table" color="primary darken-1 px-2 pb-1" dark tile levation="3" :loading="loadingList?'accent':false">
          <v-row no-gutters>
            <v-col cols="12">

              <v-row class="px-2">


                <v-btn
                class="ml-2 mr-2 mt-1"
                color="white primary--text text--darken-2"
                :disabled="loadingList"
                :small="!isMobile"
                :x-small="isMobile"
                rounded
                :fab="isMobile"
                depressed
                @click="addItem()">
                  <v-icon>add</v-icon>
                  <span v-if="!isMobile">Agregar</span>
                </v-btn>

                <v-spacer></v-spacer>


                <v-btn text icon color="white" @click="changePage('first')" :disabled="page == 1">
                  <v-icon>first_page</v-icon>
                </v-btn>
                <v-btn text icon color="white" @click="changePage(-1)" :disabled="page == 1">
                  <v-icon>chevron_left</v-icon>
                </v-btn>

                <v-chip small color="white primary--text text--darken-2" class="mt-2 mx-1">
                  <b>{{page}} </b> -- {{totalPages}}
                </v-chip>

                <v-btn text icon color="white" @click="changePage(1)" :disabled="page == totalPages">
                  <v-icon>chevron_right</v-icon>
                </v-btn>

                <v-btn text icon color="white" @click="changePage('last')" :disabled="page == totalPages">
                  <v-icon>last_page</v-icon>
                </v-btn>

                <v-spacer></v-spacer>

                <slot name="buttons"></slot>


              </v-row>
            </v-col>
            <v-col cols="12">
                <scroll-sync horizontal class="item-container-h hide-scroll " >
                  <form autocomplete="off">
        <v-container class="pa-0" fluid>
                  <v-row no-gutters v-if="actualModel">
                    <v-col class="mr-3" v-for="(input, index) in actualModel.inputs" :class="input.type+'-h'" :key="'h-'+index">
                      <div :style="{ width: input.width?input.width+'px':''}">

                      <template v-if="!input.noSearch">
                        <v-tooltip top >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                            :label="input.label"
                            @change="changeSearch()"
                            v-model="search[input.nameAttr]"
                            v-on="on"
                            single-line
                            hide-details
                            flat
                            tile
                            dense
                            autocomplete="off"
                            outlined>
                          </v-text-field>
                        </template>
                        <span>{{input.label}}</span>
                      </v-tooltip>
                    </template>

                    <span v-else>
                      {{input.label}}
                    </span>

                      </div>
                    </v-col>
                    <v-col class="actions-h"></v-col>
                  </v-row>

                  </v-container>
                  </form>
                </scroll-sync>
            </v-col>
          </v-row>
        </v-sheet >

              <scroll-sync horizontal class=" item-container scroll" >
        <v-container class="table-container pa-0" fluid>
          <v-row no-gutters v-for="(item,index) in filteredPagedList" :key="'group-'+(item.id ? item.id : index)" v-show="!loadingList" :class="index%2==0?'primary lighten-5':'white'">

            <!--
            <v-col >
                <v-card :color="index%2==0?'primary lighten-5':'white'"
                :elevation="isMobile? 4:0"
                class="tarja"
                :class="{
                  'mini': isMobile,
                  'ma-1': isMobile
                  }"
                  outlined :tile="!isMobile">
                  <v-card-text class="py-0 px-1">

                    <v-container class="pa-0" fluid>
                      <v-row no-gutters>
                      -->

                        <v-col class="mr-3" v-for="itemForm in item.form" :key="itemForm.prop" >
                          <div  :style="{ width: itemForm.width?itemForm.width+'px':''}">


                          <!--
                          <v-text-field
                          class="small"
                          v-if="itemForm.type == 'text'"
                          single-line
                          hide-details
                          outlined
                          :disabled="itemForm.prop == 'id' || itemForm.disabled"
                          :name="itemForm.label"
                          :label="itemForm.label"
                          v-model="itemForm.value"
                          @change="changeInput(itemForm, item)"
                          ></v-text-field>
                        -->

              <input
              type="text"
              v-if="itemForm.type == 'text'"
              :disabled="itemForm.prop == 'id' || itemForm.disabled"
              v-model="itemForm.value"
              @change="changeInput(itemForm, item)"
              />
<!--
                          <v-text-field
                          class="small"
                          v-if="itemForm.type == 'password'"
                          single-line
                          hide-details
                          outlined
                          type="password"
                          :disabled="itemForm.prop == 'id'"
                          :name="itemForm.label"
                          :label="itemForm.label"
                          v-model="itemForm.value"
                          @change="changeInput(itemForm, item)"
                          ></v-text-field>
-->

              <input
              v-if="itemForm.type == 'password'"
              type="password"
              v-model="itemForm.value"
              @change="changeInput(itemForm, item)"
              />
<!--
                          <v-textarea
                          class="small"
                          outlined
                          v-if="itemForm.type == 'textarea'"
                          single-line
                          hide-details
                          outlined
                          :disabled="itemForm.prop == 'id'"
                          :name="itemForm.label"
                          :label="itemForm.label"
                          v-model="itemForm.value"
                          @change="changeInput(itemForm, item)"
                          ></v-textarea>
-->
              <input
              type="text"
              v-if="itemForm.type == 'textarea'"
              :disabled="itemForm.prop == 'id'"
              v-model="itemForm.value"
              @change="changeInput(itemForm, item)"
              />

                          <v-select
                          class="small"
                          v-if="itemForm.type == 'select'"
                          single-line
                          hide-details
                          :items="itemForm.list"
                          :item-text="itemForm.itemText"
                          :item-value="itemForm.itemValue"
                          :name="itemForm.label"
                          :label="itemForm.label"
                          v-model="itemForm.value"
                          :loading="itemForm.loading"
                          @change="changeInput(itemForm, item)"
                          >
                          <template v-slot:prepend-item v-if="itemForm.model">
                            <v-list-item dense @click="addNewItemSelection(itemForm)">
                              <v-list-item-title class="blue--text darken-2">
                                Crear
                              </v-list-item-title>
                            </v-list-item>
                          </template>
                          </v-select>
<!--
                        <select
                          v-if="itemForm.type == 'select'"
                          v-model="itemForm.value">
                          <option @click="addNewItemSelection(itemForm)" > crear </option>
                          <option v-for="opt in itemForm.list" :value="opt">
                            {{ get(opt, itemForm.label) }}
                          </option>
                        </select>
                        -->





                          <add-new-item
                          v-if="itemForm.type == 'select'"
                          :model="itemForm.model"
                          v-model="itemForm.showAddDialog"
                          :item-form="itemForm"
                          @change="saveNewItemSelection"
                          ></add-new-item>




                            <v-select
                          v-if="itemForm.type == 'multiSelect'"
                              class="small"
                              single-line
                              hide-details
                              multiple
                              :items="itemForm.list"
                              :item-text="itemForm.itemText"
                              :item-value="itemForm.itemValue"
                              :name="itemForm.label"
                              :label="itemForm.label"
                              v-model="itemForm.value"
                              :loading="itemForm.loading"
                              @change="changeInput(itemForm, item)"
                              >
                              <template v-slot:selection="{ item, index }">
                                <v-chip v-if="index == 0" label small>
                                  <span>{{ item[itemForm.itemText] }}</span>
                                </v-chip>
                                <span
                                v-if="index === 1"
                                class="grey--text caption"
                                >(+{{ itemForm.value.length - 1 }})</span>
                              </template>

                            </v-select>




<!--
                                    <select
                                      multiple
                                      v-if="itemForm.type == 'multiSelect'"
                                      v-model="itemForm.value">
                                      <option v-for="opt in itemForm.list" :value="item">
                                        {{ opt[itemForm.itemText] }}
                                      </option>
                                    </select>
                      -->




                          <input type="checkbox"
                          v-if="itemForm.type == 'checkbox'"
                          v-model="itemForm.value"
                          @change="changeInput(itemForm, item)"
                          />
                          <!--
                        <v-col class="pa-0">
                        <v-checkbox
                          class="ma-0"
                          dense
                          v-if="itemForm.type == 'checkbox'"
                          :name="itemForm.label"
                          style="width:40px"
                          v-model="itemForm.value"
                          :loading="itemForm.loading"
                          @change="changeInput(itemForm, item)"
                          ></v-checkbox>
                        </v-col>
                          -->


                          <input
                          v-if="itemForm.type == 'date'"
                          type="date"
                          v-model="itemForm.value">
<!--
                          <v-menu
                          v-if="itemForm.type == 'date'"
                          ref="menu"
                          :close-on-content-click="false"
                          :return-value.sync="date"
                          transition="scale-transition"
                          offset-y
                          max-width="290px"
                          min-width="290px"
                          >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                            class="small"
                            :loading="itemForm.loading"
                            single-line
                            hide-details
                            outlined
                            v-model="itemForm.value"
                            :label="itemForm.label"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                          v-model="itemForm.value"
                          @change="changeInput(itemForm, item)"
                          no-title
                          scrollable
                          >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                          <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                        </v-date-picker>
                      </v-menu>
                    -->
                          </div>
                    </v-col>


                    <v-col class="actions">


                      <div class="icon-content d-inline-block">
                        <v-btn class=''
                         :class="{
                          'orange--text':item.dirty,
                          'green--text':item.isNew,
                          'red--text':item.saveError
                          }"
                          @click="saveItem(item)"
                          icon x-small
                          :loading="item.loading">
                          <v-icon>save</v-icon>
                        </v-btn>
                      </div>

                      <div class="icon-content d-inline-block" >
                        <v-btn class='primary--text text--lighten-2'
                          @click="removeItem(item)"
                          icon x-small :loading="item.loading">
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </div>

                    </v-col>




                    <!--
                  </v-row>
                </v-container>
              </v-card-text>

            </v-card>
        </v-col>
      -->

      </v-row>
      <v-row v-show="loadingList" no-gutters>
        <v-col cols="12" class="pa-4">
          <v-alert :value="true" border="left" icon="find_in_page" prominent text>
            Cargando
            <v-progress-linear color="accent" :indeterminate="true"></v-progress-linear>
          </v-alert>
        </v-col>
      </v-row>

    </v-container>
          </scroll-sync>


</div>

</template>

<script>



/**

transform: transforma datos dentro de una instancia del actualModel
            usado para mapear al cargar la informacion

path: ruta de la cual se obtienen las instancias del actualModel
      muchas veces las rutas GET traen datos adicionales

ATTR inputs models
  - label: Nombre que aparecera en el input
  - nameAttr
  - default
  - defaultFirst
  - disabled
  - required
  - type : tipo de input
  - model : modelo del cual se sacan los datos para el input
  - searchPath
  - modelTo: modelo en el que se guardara el dato (distinto al actualModel)
  - width
  - path
  - rootPath

*/

import _ from "lodash";
  import ScrollSync from 'vue-scroll-sync';
  import addNewItem from '@/components/addNewItem'

export default {
  name: "modelEditor",
  props:[
    "model", //       {name : "usuarios",       model : "userModel"},
  ],
  components: {
          'scroll-sync': ScrollSync,
          'add-new-item': addNewItem
  },
  created() {
    this.init();
  },
  data: () => ({
    actualModel       : null,
    search            : {},
    list              : [],
    models            : [],
    listsModel        : {},
    itemSelected      : null,
    itemSelectedForm  : null,
    loadingForm       : false,
    loadingList       : false,
    inputs            : [],
    page              : 1,
    totalPages        : 1,
    pageSize          : 13,
    filteredList      : [],
    filteredPagedList : []
  }),
  watch:{
    model(){
      this.init();
    },
    empresaSelected(to, from){
      if(from != to){
        this.init();
      }
    }
  },
  computed:{
    empresaSelected(){
      return this.$store.getters.empresaSelected;
    },
    isMobile(){
      return this.$store.getters.isMobile;
    },
  },
  methods: {
    init() {
      if(this.model){
        this.loadingList = true;
        this.importModel().then(res => {
          this.actualModel = res.default;
          var p = this.getModels()
          p.then(res => {
            this.getAllData().then(()=>{
              this.changeSearch();
            });
          });
        }, res =>{
          console.error("error import");
          this.loadingList = false;
        })
      }
    },

    changePage(num){
      if(num == "first"){
        this.page = 1;
      }else if(num == "last"){
        this.page = this.totalPages;
      }else if(_.isNumber(num)){
        this.page += num;
      }
      this.refreshPages();
    },

    changeSearch(){
      console.log("changeSearch");
      var list = _.filter(this.list, item => {
        var find = true;
        _.forEach(this.search, (itemSearch, key) => {
          if(itemSearch != "" && itemSearch !== null){
            this.page = 1; // vuelve a la pagina inicial cuando busca
            var input     = _.find(this.actualModel.inputs, {nameAttr:key})
            var itemValue = _.get(item, key);
            if(input && input.searchPath){
              // obtiene el item del form
              var inputForm      = _.find(item.form, {prop:key});
              // obtiene el item de list que se ha seleccionado
              var itemFormValue  = _.find(inputForm.list, {id: inputForm.value});
              //sobreescribe el itemValue por el searchPath del itemFormValue
              //asi remplaza la id por el nombre en el itemValue, para compararlo con el itemSearch
              itemValue          = _.get(itemFormValue, input.searchPath);
            }
            if(typeof itemValue == "number"){
              itemValue = itemValue.toString();
            }
            if(itemValue){
              if(!itemValue.toLowerCase().includes(itemSearch.toLowerCase())){
                find = false;
              }
            }
          }
        });
        return find;
      });
      this.filteredList = list;

      this.refreshPages();

    },

    refreshPages(){
      var offset             = (this.page - 1) * this.pageSize;
      this.totalPages        = _.ceil(this.filteredList.length / this.pageSize);
      this.filteredPagedList = _.drop(this.filteredList, offset).slice(0, this.pageSize);
    },


    get(v, path){
      return _.get(v, path);
    },


    getAllData(){
      this.loadingList = true;
      return this.actualModel.all({
        params:{empresa_id : this.empresaSelected.id}
      })
      .then(res => {
      var data = res.data[this.actualModel.varName] || res.data.data;
        if(this.actualModel.grouped){
          data = _.flatMap(data);
        }
        if(this.actualModel.path){
          data = _.get(data, this.actualModel.path);
        }

        if(this.actualModel.transform){
          _.forEach(data, item => {
          _.forEach(this.actualModel.transform, (tr) => {
            if(item[tr[0]]){
              item[tr[1]] = tr[2](item);
            }
          })
          })
        }

        _.forEach(data, item => {
          //item.form = await
          this.madeForm(item);
          item.dirty     = false;
          item.loading   = false;
          item.saveError = false;
          item.isNew     = false;
        })

        this.list = _.orderBy(data, ["id"], ["desc"]);
        this.loadingList = false;
      })
    },


    /*
      obtiene todos los datos de cada modelo que usa el actualModel
    */
    getModels(){
      var promises = [];
      var models = [];

      if(this.actualModel.relations){
        _.forEach(this.actualModel.relations, rel => {
          models.push(rel[0]);
        })
      }

      this.actualModel.inputs.forEach(input =>{
        if(input.model){
          models.push(input.model);
        }
      });

      _.forEach(models, modelName =>{
        var p = this.importModel(modelName)
        .then(model => {
          return model.default.all({
            params:{empresa_id : this.empresaSelected.id}
          })
          .then( res => {
            var data = res.data.data;
            if(model.default.grouped){
              data = _.flatMap(data);
            }
            this.listsModel[modelName] = data;
          });
        })
        promises.push(p);
      });

      return Promise.all(promises);
    },

    importModel(model){
      model = model || this.model.model;
      if(this.models[model]) return Promise.resolve(this.models[model]);
      return import('@/models/'+ model).then(modelRes => this.models[model] = modelRes)
    },



    addItem(){
      var newItem        = {};
      newItem            = this.actualModel.new();
      newItem.empresa_id = this.empresaSelected.id;
      newItem.isNew      = true;
      newItem.loading    = false;
      newItem.saveError  = false;

      /*
      var promises = [];
      _.forEach(this.actualModel.relations, rel => {
        this.importModel(rel[0]).then(model =>{
          newItem[_.camelCase(model.default.resource)] = model.default.new();
        })
      })
      //newItem.form       =
      Promises.all(promises).then(res =>{
      */
        this.madeForm(newItem);
        this.list.unshift(newItem);
        this.changeSearch();
      //})
    },

    removeItem(item){
      var self = this;
      if(confirm("seguro desea eliminar este item")){
        item.loading = true;
        if(item.isNew){
          var index    = this.list.indexOf(item);
          this.list.splice(index, 1);
        }else{
        this.actualModel.delete(item.id).then(res => {
          item.loading = true;
          var index    = this.list.indexOf(item);
          this.list.splice(index, 1);
          this.changeSearch();

          if(this.actualModel.relations){
            _.forEach(this.actualModel.relations, attr => {
              var p = this.importModel(attr[0])
              .then(model => {
                var a = item[_.camelCase(model.default.resource)];
                if(a && a.id){
                  model.default.delete(a.id).then(res=>{
                    console.log("resource deleted > "+model.default.resource);
                  }, resError => {
                    console.error(resError);
                  })
                }
              })
            })
          }

          }, resError =>{
          console.error(resError);
        });
        }
      }
    },

    editItem(item){
      //this.itemSelected = item;
    },
    saveItem(item){
      item.loading   = true;
      item.saveError = false;
      var itemData   = {};

      _.forEach(item.form, (node) =>{
        //si el input no tiene modelTo, asigna el valor directamente
        if(node.modelTo === undefined){
          itemData[node.prop] = node.value;
        }
        //mapea datos antes de guardado
        if(node.input.mapSaveFn){
          itemData[node.prop] = node.input.mapSaveFn(node);
        }
        node.valueOriginal = _.cloneDeep(node.value);
      })


      //guarda datos
      this.actualModel.saveOrAdd(itemData)
      .then(async res => {


        if(item.id === null && res.data.id){
          this.saveForm(item);
          item.id = res.data.id;
          //item.form = await
          await this.madeForm(item);
          item.isNew = false;
        }


        //carga informacion de las relaciones de actualModel.relations
        //importa los modelos indicados y se los asigna a cada item

        //formato relations:[["contratoModel", "trabajador_id", "id"]],

        _.forEach(this.actualModel.relations, rel =>{

          //promises.push(node.model.saveOrAdd(node));
          var dataForm    = _.filter(item.form, {modelTo: rel[0]});
          var data        = {};
          var dataForm_id = null

          _.forEach(dataForm, (node) =>{
            var prop = _.last(node.prop.split("."));
            data[prop] = node.value;
            if(prop == "id"){
              dataForm_id = node;
            }
          })

          data[rel[1]] = item[rel[2]]; //id

          this.importModel(rel[0]).then(model => {
            return model.default.saveOrAdd(data).then(res => {
              if(res.data.id){
                item[_.camelCase(model.default.resource)].id = res.data.id;
                if(dataForm_id){
                  dataForm_id.value = res.data.id;
                }
              }
            });
          });

        })

        _.forEach(item.form, (node) =>{
          itemData.dirty = false;
        })

        item.dirty = false;
        item.loading = false;

      }, resError =>{
        console.error(resError);
        this.$store.commit("showSnackBar", resError.response.data.msg);
        item.loading = false;
        item.saveError = true;
      });
    },


    cancelSaveItem(){
      //this.itemSelectedForm  = _.map(this.itemSelected, (value, prop) => ({ prop, value }));
      //this.madeForm(this.itemSelected);
    },
    saveForm(item){
      item.form.forEach(input=>{
        item[input.prop] = input.value;
      });
    },

    madeForm(item){
      if(item == null || item == undefined) return;
      var self = this;
      var promises = [];
      item.form = null;


      //agrega relations al item
      if(this.actualModel.relations){
        _.forEach(this.actualModel.relations, attr => {
          var p = this.importModel(attr[0])
          .then(model => {
            var data = {};
            data[attr[1]] = item[[attr[2]]]; //id
            var valueObj = _.find(self.listsModel[attr[0]], data);
            if(valueObj){
              item[_.camelCase(model.default.resource)] = valueObj;
            }else{
              item[_.camelCase(model.default.resource)] = model.default.new();
            }
          })
          promises.push(p);
        })
      }
      //se usa promises, porque las relaciones deben estar hechas antes de hacer el formulario
      return Promise.all(promises).then(res => {
        var itemSelectedForm = this.actualModel.inputs.map( input =>{

          var itemForm = {
            disabled      : input.disabled,
            required      : input.required,
            label         : input.label,
            prop          : input.nameAttr,
            width         : input.width,
            type          : input.type,
            itemText      : "nombre",                   // default
            itemValue     : "id",                   // default
            loading       : false,
            input         : input,
            showAddDialog : false,
            dirty         : false
          }

          if(input.renameAttr){
            item[input.renameAttr] = _.get(item, input.nameAttr)
            itemForm.prop          = input.renameAttr;
          }

          itemForm.value = _.get(item, input.nameAttr);

          //para detectar datos de otro modelo
          if (input.modelTo) {
            itemForm.modelTo = input.modelTo;
          }

          //en el caso de que el texto sea otro, aparte de "nombre" [default]
          if(input.itemText){
            itemForm.itemText = input.itemText;
          }

          if(input.itemValue){
            itemForm.itemValue = input.itemValue;
          }


          //map es para convertir un array de itemFormen un array de ids (u otro atributo)
          //usado para multiSelect
          if(input.map){
            console.log("input map");
            itemForm.value = _.map(item[input.nameAttr], itemObj => {
              return itemObj[input.map]
            })
          }

          //nameAttrMap es el atributo que guardara el resultado
          //de un map, generalmente usado para multiSelect
          if(input.nameAttrMap){
            itemForm.prop = input.nameAttrMap;
          }

          //agrega los items del model en el atributo itemForm.list
          if(input.model){
            itemForm.model = input.model;
            if(self.listsModel[input.model] == undefined){
              itemForm.loading = true;
              //ºconsole.error("import innecesario");
              self.importModel(input.model).then(model => {
                model.default.all({
                  params:{empresa_id : self.empresaSelected.id}
                }).then( res => {

                  var data = res.data.data;

                  if(input.rootPath){
                    data = _.get(res, input.rootPath);
                  }

                  if(input.grouped){
                    data = _.flatMap(data);
                  }

                  if(input.path){
                    data = _.get(data, input.path);
                  }

                  // if(input.label == "Roles"){
                  //   debugger;
                  // }

                  self.listsModel[input.model] = data;
                  itemForm.loading             = false;
                  itemForm.list                = data;

                  if(input.mapValueFn){
                    itemForm = input.mapValueFn(itemForm, item);
                  }

                  if(input.defaultFirst && itemForm.value == null && itemForm.list.length > 0){
                    itemForm.value = _.first(itemForm.list).id;
                  }

                })
              })
            }else{
              itemForm.list = self.listsModel[input.model];
              if(input.mapValueFn){
                itemForm = input.mapValueFn(itemForm, item);
              }
              if(input.defaultFirst && itemForm.value == null && itemForm.list.length > 0){
                itemForm.value = _.first(itemForm.list).id;
              }
            }
          }

          itemForm.valueOriginal = _.cloneDeep(itemForm.value);


          return itemForm;
        })
        //en las promesas, muchas veces vue no detecta cambios en variables nuevas
        //form es declarada al inicio de la funcion y actualizada en el $nextTick
        this.$nextTick(function () {
          item.form = itemSelectedForm;
        })
      })

      //return itemSelectedForm;
    },
    changeInput(itemForm, item){
      itemForm.dirty = true;
      item.dirty = true;
    },
    addNewItemSelection(itemForm){
      itemForm.showAddDialog = true;
    },
    saveNewItemSelection(item, itemForm){
      itemForm.showAddDialog = false;
      itemForm.list.push(item)
      itemForm.value = item.id;
    }
  }
}
</script>
<style lang="scss" scoped>

.model-table-editor{
  overflow: hidden;


  .header-table {
    position: sticky;
    top: 0;
    //width: 100%;
    z-index: 1;
    height: auto !important;
    .item-container-h {
      overflow-x: scroll;
      form {
        width: auto;
        .container {
          width: max-content !important;
          max-width: unset !important;
          margin: 0;
          padding: 0;
        }
      }
      .row {
        .col > div {
          //width: unset;
          width: 200px;
          //flex-grow: 0;
        }
      }
    }
  }

  .item-container.scroll-sync-container {
    width: auto;
    overflow: scroll;
    height: calc(100vh - 150px);
    .table-container,
    .table-container .tarja .container {
      //width: auto !important;
      width: max-content !important;
      max-width: unset !important;
      //min-width: 100%;
      margin: 0;
      padding: 0;
    }
  }

  // --------
  .table-container {
    .tarja,
    .row {
      padding: 3px 8px;
      & .col > div > select {
        border-radius: 0;
        flex: 1 0 0;
        width: inherit;
        min-width: auto;
        max-width: unset;
        background: white;
        cursor: pointer;
        box-shadow: inset 0 0 2px grey;
        height: 30px;

      }
      & .col > div:not(.v-alert):not(.icon-content) {
        width: 200px;
        & > input {
          flex: 1 0 0;
          width: inherit;
          min-width: auto;
          max-width: auto;
          &[type="password"] ,
          &[type="text"] {
            background: rgba(255, 255, 255, 0.2);
            box-shadow: inset 0 0 2px grey;
            padding: 2px 4px;
            height: 30px;
          }
        }
      }

      & > .col {
        flex-grow: 0;
      }
      .v-select {
        margin: 2px;
        padding: 0;
      }

    }
  }

  /* Tamaño del scroll */
  .scroll {
    &::-webkit-scrollbar {
      height: 10px;
      width: 10px;
    }
    &::-webkit-scrollbar-track {}
    &::-webkit-scrollbar-thumb {
      background: rgba(239,108,0,0.5); //rgba(0, 0, 0, 0.1);
      border-radius: 4px;
      transition: all 1s ease;
      &:active,
      &:hover {
        background: rgba(239,108,0,1);
      }
    }
  }

  .hide-scroll {
    &::-webkit-scrollbar {
      height: 0;
    }
    &::-webkit-scrollbar-track {}
    &::-webkit-scrollbar-thumb {
      //background: rgba(0, 0, 0, 0.1);
      background: #90a4ae;
      border-radius: 4px;
      transition: all 1s ease;
      &:active,
      &:hover {
        //background: rgba(0, 0, 0, 0.3);
        background: #455a64;
      }
    }
  }

  .add-btn {
    bottom: 0 !important;
    position: absolute;
    margin: 0 0 16px 16px;
  }

  .actions-h,
  .actions {
    min-width: 100px;
    max-width: 100px;
    overflow: hidden;
  }
}
</style>
